import Img from './statistics.png';
import './Statistics.css';

const Statistics = () => {
    return (
        <img className='img-statistics' src={Img} alt="" />
    );
}

export default Statistics;
